export default __webpack_public_path__ + "/dist/images/banner-video.mp4";